<template>
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="computedSeries"
      
    />
  </template>

  <script>
  import VueApexCharts from 'vue-apexcharts'
  
  export default {
    name: 'HorizentalBarChart',
    components: {
      apexchart: VueApexCharts
    },
    props: {
      labels: {
        type: Array,
        required: true
      },
      values: {
        type: Array,
        required: true
      },
      useColors: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: '#2ecc71' 
      },
      colors: {
        type: Array,
        default: () => [
          '#008FFB', // blue
          '#00E396', // green
          '#FEB019', // yellow
          '#FF4560', // red
          '#775DD0', // purple
          '#3F51B5', // indigo
          '#546E7A', // blue gray
          '#D4526E', // pink red
          '#8D5B4C', // brown
          '#F86624', // orange
          '#2E294E', // deep blue
          '#1B998B', // teal
          '#9C27B0'  // violet
        ]
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {
      computedSeries() {
        return [
          {
            name: 'Value',
            data: this.values
          }
        ]
      },
      chartOptions() {
        return {
          chart: {
            type: 'bar',
            height: 350,
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4,
              barHeight: '50%',
              distributed: this.useColors 
            }
          },
          colors: this.useColors ? this.colors : [this.color],
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return window.innerWidth < 576 ? '' : val +  ' %';
            },
            style: {
              fontSize: '14px'
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' %';
              }
            }
          },
          xaxis: {
            categories: this.labels
            
          },
          yaxis: {
            labels: {
              show: !this.useColors
            }
          },
          title: {
            text: this.title,
            align: 'center'
          }
        }
      }
    }
  }
  </script>
  
  <style scoped>
  </style>
  